export default `<h1 id="free-ai-assessment">Free AI Assessment</h1>
<p>Complete this short questionnaire to receive a personalised snapshot
of your organisation’s AI readiness and opportunities. We’ll email your
report within 24 hours.</p>
`;
